import { BtnRoundelFramed } from './BtnRoundelFramed';
import { BtnSesame } from './BtnSesame';

export class BtnScenarioSelect extends BtnRoundelFramed {
  constructor(scene, x, y, { id, scenarioid, played, active, hoverVO, enabled }) {
    super(scene, x, y, {
      thumbSheet: 'scenario_select',
      thumbKey: `scenario_thumb_${scenarioid}`,
      frame: played ? BtnRoundelFramed.FRAME.GOLD : BtnRoundelFramed.FRAME.WHITE,
      showCheck: played,
      active,
      hoverVO,
      enabled,
      id,
    });
    this.played = played;
  }
}
